module.exports = __webpack_public_path__ + "70eb96b97bed7d06e7c180dba432a209.pdf";